import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "InstrumentvariantenModalCreate",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    close: {
      type: Function,
      default: () => {},
    },
    selectorClose: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      model: {},
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "instrument",
            type: "select",
            label: "_LBL_INSTRUMENT_",
            required: true,
            keyLabel: "foi_kbez",
            keyId: "pk",
            view: "v",
            url: "foerderinstrumente/?fields=pk&fields=foi_kbez",
          },
          {
            id: "fiv_kbez",
            type: "text",
            label: "_LBL_INSTRUMENTVARIANTEN_MODAL_CREATE_KURZBEZEICHNUNG_",
            required: true,
            maxlength: 60,
            view: "v",
          },
          {
            id: "fiv_bez",
            type: "textarea",
            label: "_LBL_INSTRUMENTVARIANTEN_MODAL_CREATE_BEZEICHNUNG_",
            required: true,
            maxlength: 200,
            view: "v-alt",
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  methods: {
    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.postHttp({ url: `foerderinstrumentvarianten/`, data }).then(
        response => {
          this.addNotification({ text: "_MSG_INSTRUMENTVAR_MODAL_CREATE_SUCCESS_" });
          this.close();
          this.$goTo("root.foerderinstrumentvarianten.detail", { id: response.pk });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
